import { render, staticRenderFns } from "./leftGym.vue?vue&type=template&id=b033abc6&scoped=true"
import script from "./leftGym.vue?vue&type=script&lang=js"
export * from "./leftGym.vue?vue&type=script&lang=js"
import style0 from "./leftGym.vue?vue&type=style&index=0&id=b033abc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b033abc6",
  null
  
)

export default component.exports